import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import MyDialog from '@/components/MyDialog.vue';
import { capitalize, chain, startCase } from 'lodash';
import MySelect from '@/components/MySelect.vue';
const skillsModule = namespace('skills');
const equipmentModule = namespace('equipment');
let CharacterSheetProficienciesList = class CharacterSheetProficienciesList extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.isExpertise = false;
        this.chosenCategory = '';
        this.newProficiency = '';
        this.toolCategories = ['Tool', 'MusicalInstrument', 'Kit', 'GamingSet'];
    }
    created() {
        this.fetchSkills();
        this.fetchEquipment();
    }
    get allProficiencies() {
        return {
            Weapons: [
                'Simple Vibroweapons',
                'All Vibroweapons',
                'Simple Lightweapons',
                'All Lightweapons',
                'Simple Blasters',
                'All Blasters',
                ...this.equipment.filter(({ equipmentCategory }) => equipmentCategory === 'Weapon').map(({ name }) => name)
            ],
            ...chain(this.equipment)
                .filter(({ equipmentCategory }) => this.toolCategories.includes(equipmentCategory))
                .groupBy('equipmentCategory')
                .mapValues(items => items.map(({ name }) => name))
                .mapKeys((list, key) => startCase(key))
                .value(),
            Armor: ['Light Armor', 'Medium Armor', 'Heavy Armor']
        };
    }
    get customProficiencyList() {
        return chain(this.allProficiencies).mapValues(proficiencyList => proficiencyList.filter(proficiency => ![...[...this.proficiencies, ...this.customProficiencies].map(({ name }) => name), ...this.skillAndSaveProficiencies]
            .map(this.startCase)
            .includes(this.startCase(proficiency)))).omitBy((proficiencyList, category) => proficiencyList.length <= 0).value();
    }
    get proficiencyCategories() {
        return Object.keys(this.customProficiencyList);
    }
    get filteredList() {
        return this.chosenCategory ? this.customProficiencyList[this.chosenCategory] : Object.values(this.customProficiencyList).flat();
    }
    get isTool() {
        return this.toolCategories.some(category => this.allProficiencies[startCase(category)].includes(this.newProficiency));
    }
    get proficiencyType() {
        if (this.isTool)
            return 'tool';
        else if (this.allProficiencies['Weapons'].includes(this.newProficiency))
            return 'weapon';
        else if (this.allProficiencies['Armor'].includes(this.newProficiency))
            return 'armor';
        else
            return 'other';
    }
    resetValues() {
        this.chosenCategory = '';
        this.newProficiency = '';
        this.isExpertise = false;
    }
    handleAddProficiency() {
        this.$emit('updateCharacter', {
            customProficiencies: {
                [this.customProficiencies.length]: {
                    name: this.newProficiency,
                    type: this.proficiencyType,
                    proficiencyLevel: this.isExpertise ? 'expertise' : 'proficient'
                }
            }
        });
        this.isOpen = false;
    }
    startCase(input) {
        // Lodash's start case removes apostrophes, so we need a custom function to handle things like Biochemist's Kit
        return input.replace(/\w+/g, capitalize).replace("'S", "'s");
    }
    handleDelete(index) {
        this.$emit('deleteCharacterProperty', { path: 'customProficiencies', index });
    }
};
__decorate([
    Prop(Array)
], CharacterSheetProficienciesList.prototype, "proficiencies", void 0);
__decorate([
    Prop(Array)
], CharacterSheetProficienciesList.prototype, "skillAndSaveProficiencies", void 0);
__decorate([
    Prop(Array)
], CharacterSheetProficienciesList.prototype, "customProficiencies", void 0);
__decorate([
    skillsModule.State
], CharacterSheetProficienciesList.prototype, "skills", void 0);
__decorate([
    skillsModule.Action
], CharacterSheetProficienciesList.prototype, "fetchSkills", void 0);
__decorate([
    equipmentModule.State
], CharacterSheetProficienciesList.prototype, "equipment", void 0);
__decorate([
    equipmentModule.Action
], CharacterSheetProficienciesList.prototype, "fetchEquipment", void 0);
CharacterSheetProficienciesList = __decorate([
    Component({
        components: {
            ConfirmDelete,
            MyDialog,
            MySelect
        }
    })
], CharacterSheetProficienciesList);
export default CharacterSheetProficienciesList;
